module.exports = __webpack_public_path__ + "static/img/J.54bd3ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mszj/J.png
// module id = BYfN
// module chunks = 0